module.exports = __webpack_public_path__ + "img/account_security_user.9b6b97fe.svg";